const getUserManagementListUrl = '/staff/users/';

export default getUserManagementListUrl;
